
import 'core-js/es6/map';
import 'core-js/es6/set';

import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import { Provider } from 'react-redux';

import "babel-polyfill";
import 'font-awesome/css/font-awesome.css'
import './styles/index.css';

import App from './containers/App';
import loadInitialApis from './config/applicationLoader';

import registerServiceWorker from './registerServiceWorker';

import Device from "./devices/device";

import LocalStorage from '../src/components/DeviceStorage/LocalStorage';
import DeviceStorage from '../src/components/DeviceStorage/DeviceStorage';
import AAF from '../src/AAF/AAF';
import pkg from '../package.json';

async function ready() {
  const deviceObject = Device.getDevice();
  const device = deviceObject.getPlatform();

  let subplatform = '';
  if(typeof deviceObject.getSubplatform === 'function') {
    subplatform = deviceObject.getSubplatform();  
  }

  if (device === 'arris') {
    deviceObject.disableArrisKeys();
  }

  window.appReq = {
    url: [],
    data: {},
  }

  //TODO obtener mejor el HKS desde la cadena search
  if (window.location && window.location.search && window.location.search.indexOf && window.location.search.indexOf('HKS') > -1) {
    if (window.location.search.split('=') && window.location.search.split('=')[1])
      localStorage.setItem('HKS', window.location.search.split('=')[1]);
  }

  //youbora
  window.youboraParams[11].value = deviceObject && deviceObject.config && deviceObject.config.firmwareversion || '';
  window.youboraParams[13].value = pkg.version || '';

  await loadInitialApis();
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root'),
    () => {
      if (
        window.AAFFallbackApplication &&
        window.AAFFallbackApplication.getNativeModalErrorTimeoutId() !== null
      ) {
        window.AAFFallbackApplication.clearNativeModalErrorTimeoutId();
      }
      if (
        window.AAFFallbackApplication &&
        window.AAFFallbackApplication.getNativeXDKRedirectTimeoutId() !== null
      ) {
        window.AAFFallbackApplication.clearNativeXDKRedirectTimeoutId();
      }

      root.classList.add(`root-${device}`);
      if (subplatform) {
        root.classList.add(`root-${subplatform}`);
      }
    }
  );
}

/*
var idTimeoutp = null;
function ps4Debug(nIntento, max) {
  if(idTimeoutp) {
    clearTimeout(idTimeoutp);
  }

  idTimeoutp = setTimeout( () => {
    if(nIntento > max) {
      clearTimeout(idTimeoutp);
    }
    else {
      try {
        if(typeof window.WM_devSettings != 'undefined') {
            //console.info('============== Info: ', window.WV_devSettings.memoryInfo);
          console.info(nIntento + ' [PS4] DEBUG MemInfo ============================');
          console.info(window.WM_devSettings.memoryInfo);

          console.info(nIntento + ' [PS4] DEBUG callbacks WEBMAF ============================');
          console.info(window.__playstation_callbacks);
          console.info(window.__playstation_callbacks_once);
        }
        else {
          console.error(nIntento + ' [PS4] DEBUG MemInfo ============================ Info WV_devSettings no disponible');
        }
        ps4Debug(++nIntento, 30);
      }
      catch(e) {
        console.error(nIntento + ' [PS4] DEBUG MemInfo ============================ Info WV_devSettings no disponible');
      }
    }

  }, 1000);
}
*/

// Verificar por SILO correcto
// Por el momento sólo se verifica por OTT
const ottDevice = AAF.Silo.siloUtil.getOTTDevice();
console.log('[SILO] index ottDevice: ' + ottDevice);
if (ottDevice) {
  const silo = ottDevice === 'stbcoship' ? AAF.Silo.siloUtil.getSiloSTB() : ( ottDevice === 'seirobotics' ?  AAF.Silo.siloUtil.getSiloSEI() : AAF.Silo.siloUtil.getSiloTV());
  console.log('[SILO] index silo esperado: ' + silo);
  // CASO 1 Si es localhost, nada que hacer, quizá esta desarrollando local
  if (AAF.Silo.siloUtil.isLocalhost()) {
    console.log('[SILO] index es local host nada que hacer');
    ready();
  }
  // CASO 2 Si es el silo esperado ver por el HKS y el user hash en los query params
  else if(AAF.Silo.siloUtil.isCorrectSiloEndpoint(silo)) {
    const cvuh = AAF.Silo.siloUtil.getURLParamByName('cvuh', window.location.href);
    const hks = AAF.Silo.siloUtil.getURLParamByName('ks', window.location.href);
    if (cvuh && hks) {
      AAF.Silo.siloUtil.loginbyUserHash(cvuh, hks).then(
        (response) => {
          if (response && response.status && response.status === "0") {
            response = response.response;
            console.log('[SILO] login by user hash SUCCESS');
            AAF.Silo.siloUtil.setStorageItem('user_hash', response.session_userhash);
            AAF.Silo.siloUtil.setStorageItem('user_id', response.user_id);
            setTimeout(() => {
              // Recargar app after login
              window.location = '/';
            }, 50);
          }
          else {
            // Login error
            console.log('[SILO] login by user hash ERROR (carga normal)');
            ready();
          }
        }
      ).catch((err) => {
        console.log('[SILO] login by user hash, catch ERROR');
        ready();
      });
    }
    else {
      console.log('[SILO] es OTT y es el endpoint correcto, no trae user hash ni hks, carga normal');
      ready();
    }
  }
  // CASO 3 Si no es el silo esperado, redirect
  else {
    // Tiene user hash?
    const user_hash = AAF.Silo.siloUtil.getUserHash();
    const hks = AAF.Silo.siloUtil.getUserHKS();

    if(user_hash && hks) {
      // Se elimina la info del dominio anterior
      AAF.Silo.siloUtil.clearCVStorage();
      AAF.Silo.siloUtil.redirectCorrectSilo(user_hash, hks, silo);
    }
    else {
      AAF.Silo.siloUtil.redirectCorrectSilo(null, null, silo);
    }
  }
}
// IPTV sigue flujo normal
else {
  console.log('[SILO] index es IPTV, sigue flujo normal');
  ready();
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js